export enum SalesStatusEnum {
  NotContacted = "NotContacted",
  Contacted = "Contacted",
  FollowUpScheduled = "FollowUpScheduled",
  Converted = "Converted",
  NotInterested = "NotInterested",
  Unreachable = "Unreachable",
}
